<form
	[formGroup]="form"
	class="autocomplete-container"
>
	<mat-chip-list #chipList>
		<mat-chip *ngFor="let selectedValue of selectedValues" [selectable]="true"
							[removable]="true" (click)="removeValue(selectedValue)" (keydown)="removeValue(selectedValue)">
			{{selectedValue.value}}
		</mat-chip>
		<div class="input">
			<input matInput
						 #autocompleteMultiselectInput
						 autocomplete="off"
						 (focus)="select.open()"
						 name="searchTerm"
						 (keydown.enter)="selectFirstOption()"
						 (keydown.arrowup)="moveHoverNumber('UP')"
						 (keydown.arrowdown)="moveHoverNumber('DOWN')"
						 [placeholder]="placeholder"
						 formControlName="searchTerm"
						 [matChipInputFor]="chipList"
						 [matChipInputAddOnBlur]="true"
						 aria-label="State">
			<mat-select disableOptionCentering panelClass="autocomplete-mat-select" #select>
				<mat-optgroup *ngFor="let optionGroup of filtered; let firstB = first" [label]="optionGroup.label">
					<mat-option (selectstart)="optionSelected(data)" *ngFor="let data of optionGroup.data; let index = index"
											[value]="data" (click)="select.open()"
											[class.active-state]="firstB && index === hoverNumber">
						<qo-profile-image
							[size]="imageSize"
							[imageUrl]="data.imageUrl || undefined"
							[letter]="data.letters"
						></qo-profile-image>
						<span>{{data.value}}</span>
					</mat-option>
				</mat-optgroup>
			</mat-select>
		</div>
	</mat-chip-list>
</form>
